import {appCall, appSetObj, appSetVal, completeSession} from "../../../../store/application";
import {getData} from '../models/transaction';
import {changeStep} from "../../../../layouts/Content/modules/step";
import {STEPS} from '../../../../constants'
import {setLoadingContent} from "../../../../layouts/Content/modules/loadingContent";
import ss from 'socket.io-stream'
import MAYA from '../../../../maya_api'
import {getSocket} from "../../../../sockets";

// ------------------------------------
// Actions
// ------------------------------------
function setPaymentOption(value = 0) {
  return (dispatch, getStore) => {
    dispatch(appCall('setPaymentOption', value));
  }
}

function updateAmounts() {
  return (dispatch, getStore) => {
    dispatch(appCall('updateAmounts'))
  }
}

function getAccounts(customer_id) {
  return (dispatch, getStore) => {
    dispatch(appCall('getAccountsByCustomer', {customer_id: customer_id}))
  }
}

function sendBillImage() {
  return async(dispatch, getStore) => {
    const socket = getSocket();
    const imageUrl = getStore().scanner.imageFront;

    const image = await fetch(imageUrl);
    const imageBlob = await image.blob();

    const encodedSession = await MAYA.getEncodedSession();

    let stream = ss.createStream();

    ss(socket).emit('/h/camera/images', {
      images: [{
        argument: 1,
        size: imageBlob.size,
        format: 'png',
        width: 0,
        height: 0,
        stream: stream
      }],
      device_guid: encodedSession.device_guid,
      server_data: encodedSession.encoded_session_data
    });

    ss.createBlobReadStream(imageBlob).pipe(stream);

    dispatch(appSetVal('bill_image_processing', true));
  }
}


function submitTransaction(extraModel = null){
  return async(dispatch, getStore) => {
    dispatch(setLoadingContent(true));
    dispatch(appSetVal('init_payment_done', false));

    const sessionData = getData(getStore, extraModel);
    if(!sessionData) return fail();

    dispatch(appSetObj(sessionData, true));

    let result = null;

    if(sessionData.account !== 'EXTRACTED FROM IMAGE'){
      result = await dispatch(appCall('checkAccountNumber'));
      if(!(result && result.check_account_success)) return fail();
    }

    result = await dispatch(appCall('initPayment'));

    if(!result) return fail();

    return success();

    function success() {
      dispatch(setLoadingContent(false));
      dispatch(appSetVal('init_payment_success', true));
      dispatch(completeSession());
      return dispatch(changeStep(STEPS.SHOPPING_CART));
    }

    function fail() {
      dispatch(setLoadingContent(false));
      dispatch(appSetVal('init_payment_done', true));
      dispatch(appSetVal('init_payment_success', false));
      return false;
    }
  };
}

export {
  setPaymentOption,
  updateAmounts,
  submitTransaction,
  getAccounts,
  sendBillImage
};



// WEBPACK FOOTER //
// ./src/components/Applications/PayAnyBill/modules/billpayment.js